import {
    CUSTOMERS_LOADING,
    CUSTOMERS_SUCCESS,
    CUSTOMERS_FAIL,
    CUSTOMER_GET_SUCCESS,
    CUSTOMER_CREATE_SUCCESS,
    CUSTOMER_UPDATE_SUCCESS,
    CUSTOMER_DELETE_SUCCESS,
    CUSTOMERS_CLEAR_ERRORS,
    CUSTOMERS_CLEAR_CURRENT,
    CUSTOMERS_SET_PAGINATION
} from '../actions/CustomerActions';

const initialState = {
    customers: [],
    currentCustomer: null,
    loading: false,
    error: null,
    validationErrors: null,
    pagination: {
        total: 0,
        totalItems: 0,
        page: 1,
        limit: 20,
        totalPages: 0
    }
};

const CustomerReducer = (state = initialState, action) => {    
    switch (action.type) {
        case CUSTOMERS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null
            };

        case CUSTOMERS_SUCCESS:
            return {
                ...state,
                loading: false,
                customers: action.payload,
                error: null,
                validationErrors: null
            };

        case CUSTOMER_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                currentCustomer: action.payload,
                error: null,
                validationErrors: null
            };

        case CUSTOMER_CREATE_SUCCESS:
            return {
                ...state,
                loading: false,
                customers: [action.payload, ...state.customers],
                currentCustomer: action.payload,
                error: null,
                validationErrors: null
            };

        case CUSTOMER_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                customers: state.customers.map(customer =>
                    customer.id === action.payload.id ? action.payload : customer
                ),
                currentCustomer: action.payload,
                error: null,
                validationErrors: null
            };

        case CUSTOMER_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                customers: state.customers.filter(
                    customer => customer.id !== action.payload
                ),
                error: null,
                validationErrors: null
            };

        case CUSTOMERS_SET_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            };

        case CUSTOMERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.validationErrors || null
            };

        case CUSTOMERS_CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                validationErrors: null
            };

        case CUSTOMERS_CLEAR_CURRENT:
            return {
                ...state,
                currentCustomer: null,
                error: null,
                validationErrors: null
            };

        default:
            return state;
    }
};

export default CustomerReducer;
